import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { isEmpty } from 'ramda';
import { Link } from 'react-router-dom';

import magic from '../../util/magic';

import Card from '../Card';
import Avatar from '../Avatar';

const propTypes = {
  announcements: PropTypes.array,
  className: PropTypes.string,
};

const Announcements = ({ announcements, className }) => {
  if (isEmpty(announcements)) return <noscript />;

  return (
    <Slider className={className} autoplay autoplaySpeed={5000}>
      {announcements.map((announcement) => (
        <Card
          announcement
          membership={announcement.type == magic.membershipAnnouncement}
          symposium={announcement.type == magic.symposiumAnnouncement}
          training={announcement.type == magic.trainingAnnouncement}
          key={announcement.id}
        >
          <div className="d-flex flex-row align-items-center">
            {announcement.image && <Avatar className="mr-3 flex-shrink-0 d-none d-md-block" src={announcement.image} />}
            <div>
              <p>{announcement.title}</p>
              <p>{announcement.body}</p>
              {announcement.actionUrl && (
                <a className="btn btn-outline-light" href={announcement.actionUrl} target="_blank">
                  {announcement.actionText}
                </a>
              )}
            </div>
          </div>
        </Card>
      ))}
    </Slider>
  );
};

Announcements.propTypes = propTypes;

export default Announcements;
